import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { userService } from '../services/api';
import MarketingNav from '../components/layout/MarketingNav';
import MarketingFooter from '../components/layout/MarketingFooter';

const CertificatePage = () => {
  const { certificateId } = useParams();
  const [certificate, setCertificate] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCertificate = async () => {
      try {
        const response = await userService.getCertificate(certificateId);
        setCertificate(response.data.data.certificate);
      } catch (err) {
        setError(err.response?.data?.message || 'Certificate not found.');
      }
    };

    loadCertificate();
  }, [certificateId]);

  if (error) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-neutral-50 px-6 py-12">
        <div className="max-w-lg rounded-soft border border-neutral-200 bg-white p-8 text-center">
          <h1 className="text-2xl font-semibold text-neutral-900">Certificate Unavailable</h1>
          <p className="mt-2 text-neutral-600">{error}</p>
        </div>
      </main>
    );
  }

  if (!certificate) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-neutral-50 px-6 py-12">
        <div className="text-neutral-600">Loading certificate...</div>
      </main>
    );
  }

  return (
    <>
      <MarketingNav transparent={false} />
      <main className="min-h-screen bg-neutral-50 px-6 py-12 mt-20">
      <style>{`
        @media print {
          body { background: #ffffff; }
          .print-hidden { display: none !important; }
          .print-card { box-shadow: none !important; border: 1px solid #D9E5E7; }
        }
      `}</style>
      <div className="mx-auto mb-6 flex max-w-3xl justify-end print-hidden">
        <button
          type="button"
          onClick={() => window.print()}
          className="rounded-soft border border-primary-200 bg-primary-50 px-4 py-2 text-sm font-medium text-primary-700"
        >
          Download / Print PDF
        </button>
      </div>
      <div className="mx-auto max-w-3xl rounded-soft-lg border border-neutral-200 bg-white p-10 shadow-soft-lg print-card">
        <div className="text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-primary-500">MHDF Momentum</p>
          <h1 className="mt-4 text-4xl font-display font-semibold text-neutral-900">Certificate of Completion</h1>
          <p className="mt-2 text-neutral-600">365-Day Mental Wellness Companion Program</p>
        </div>

        <div className="mt-10 text-center">
          <p className="text-lg text-neutral-600">This certifies that</p>
          <p className="mt-3 text-3xl font-semibold text-primary-700">
            {certificate.fullName}
          </p>
          <p className="mt-4 text-neutral-600">
            has completed {certificate.programLength} days of the MHDF Momentum mental wellness companion program.
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center gap-2 text-sm text-neutral-500">
          <p>Completion Date: {certificate.graduatedAt ? new Date(certificate.graduatedAt).toLocaleDateString() : '—'}</p>
          <p>Certificate ID: {certificate.certificateId}</p>
          <p>Issued: {certificate.issuedAt ? new Date(certificate.issuedAt).toLocaleDateString() : '—'}</p>
        </div>

        <div className="mt-10 border-t border-neutral-200 pt-6 text-center text-sm text-neutral-500">
          MHDF Technologies LLC • MHDF Momentum Project
        </div>
      </div>
      </main>
      <MarketingFooter />
    </>
  );
};

export default CertificatePage;
